// import {CATEGORY_NAME} from "../../../../../enum";
// import {PATHS} from "../../../../routers/utils/Paths.links";
//
// export const filterCategoryResult = (activeCategory, dataProducts, typeServer) => {
//
//
//     return dataProducts.filter((product) => {
//         if (activeCategory.name === CATEGORY_NAME.ALL) {
//             return true;
//         } else {
//             const filterProducts: string[] = [];
//             product.categories?.map((category) => filterProducts.push(category))
//             return !filterProducts.includes(activeCategory._id);
//         }
//     })
// }

//
//
// import { CATEGORY_NAME } from "../../../../../enum";
// import { PATHS } from "../../../../routers/utils/Paths.links";
//
// export const filterCategoryResult = (activeCategory, dataProducts, typeServer) => {
//     const blockedServers = [
//         "690fe4e36faef7b438a8df7b",
//         "6803ac6b51c83e932bcfeb99"
//     ];
//
//     let filteredProducts;
//     if (typeServer !== PATHS.SHOPLITE) {
//         filteredProducts = dataProducts.filter(product => {
//             return !product.servers.some(server => blockedServers.includes(server));
//         });
//     } else {
//         filteredProducts = [...dataProducts];
//     }
//
//     return filteredProducts.filter((product) => {
//         if (activeCategory.name === CATEGORY_NAME.ALL) {
//             return true;
//         } else {
//             const filterProducts: string[] = [];
//             product.categories?.map((category) => filterProducts.push(category))
//             return !filterProducts.includes(activeCategory._id);
//         }
//     })
// };


import { CATEGORY_NAME } from "../../../../../enum";

export const filterCategoryResult = (activeCategory, dataProducts, typeServer) => {
    const NASDARA_SERVER_ID = "677dcd76a3b0a911f52c4932";

    let filteredProducts = [...dataProducts];

    // Если выбран NASDARA, скрываем товары, у которых этот сервер в списке исключённых
    if (typeServer === "nasdara") {
        filteredProducts = filteredProducts.filter(product => {
            return !product.servers?.includes(NASDARA_SERVER_ID);
        });
    }

    // Фильтруем по категории
    return filteredProducts.filter((product) => {
        if (activeCategory.name === CATEGORY_NAME.ALL) {
            return true;
        } else {
            const filterProducts: string[] = [];
            product.categories?.map((category) => filterProducts.push(category))
            return !filterProducts.includes(activeCategory._id);
        }
    })
};
